export const BILLING_MODE_TOKEN = 'token';
export const BILLING_MODE_VIDEO = 'video_token';

export const VIDEO_RESOLUTIONS = ['480p', '720p', '1080p', '4k'];

export const VIDEO_INPUT_MODES = [
  { key: 'excl', value: 'excl_video_ref', text: 'Excl. video reference (text/image)' },
  { key: 'incl', value: 'incl_video_ref', text: 'Incl. video reference input' },
];

export const FEATURED_SLOTS = [
  { key: 1, value: 1, text: 'Slot 1' },
  { key: 2, value: 2, text: 'Slot 2' },
  { key: 3, value: 3, text: 'Slot 3' },
  { key: 4, value: 4, text: 'Slot 4' },
];

export function isVideoBillingMode(mode) {
  return mode === BILLING_MODE_VIDEO;
}

export function usdPerMFromRatio(modelRatio) {
  const r = Number(modelRatio);
  if (!r || r <= 0) return null;
  return 2 * r;
}

export function emptyBillingRate() {
  return {
    billing_mode: BILLING_MODE_TOKEN,
    model_ratio: '',
    completion_ratio: '',
    video_input_mode: 'excl_video_ref',
    resolution_tiers: Object.fromEntries(VIDEO_RESOLUTIONS.map((r) => [r, ''])),
  };
}

export function emptyFeaturedEntry() {
  return { enabled: false, slot: 1, tagline: '' };
}

export function normalizeBillingRate(raw) {
  const base = emptyBillingRate();
  if (!raw || typeof raw !== 'object') return base;
  const mode = raw.billing_mode === BILLING_MODE_VIDEO ? BILLING_MODE_VIDEO : BILLING_MODE_TOKEN;
  const tiers = { ...base.resolution_tiers };
  if (raw.resolution_tiers && typeof raw.resolution_tiers === 'object') {
    VIDEO_RESOLUTIONS.forEach((k) => {
      if (raw.resolution_tiers[k] != null && raw.resolution_tiers[k] !== '') {
        tiers[k] = raw.resolution_tiers[k];
      }
    });
  }
  return {
    billing_mode: mode,
    model_ratio: raw.model_ratio ?? '',
    completion_ratio: raw.completion_ratio ?? '',
    video_input_mode: raw.video_input_mode || 'excl_video_ref',
    resolution_tiers: tiers,
  };
}

export function normalizeFeaturedEntry(raw) {
  if (!raw || typeof raw !== 'object') return emptyFeaturedEntry();
  return {
    enabled: !!raw.enabled,
    slot: raw.slot >= 1 && raw.slot <= 4 ? raw.slot : 1,
    tagline: raw.tagline || '',
  };
}

/** Show typical-market reference only when our rate is at or below catalog reference (selling point). */
export function shouldShowTypicalMarket(row) {
  if (!row) return false;
  const refIn = Number(row.reference_input_usd_per_m) || 0;
  const refOut = Number(row.reference_output_usd_per_m) || 0;
  if (refIn <= 0 && refOut <= 0) return false;

  const sellIn = Number(row.input_usd_per_m ?? row.video_usd_per_m) || 0;
  const sellOut = Number(row.output_usd_per_m ?? row.video_usd_per_m) || 0;

  if (refIn > 0 && sellIn > 0 && sellIn > refIn + 1e-6) return false;
  if (refOut > 0 && sellOut > 0 && sellOut > refOut + 1e-6) return false;
  return sellIn > 0 || sellOut > 0;
}
